import { render, staticRenderFns } from "./TpvKo.vue?vue&type=template&id=f0d3df6e&scoped=true&"
import script from "./TpvKo.vue?vue&type=script&lang=js&"
export * from "./TpvKo.vue?vue&type=script&lang=js&"
import style0 from "./TpvKo.vue?vue&type=style&index=0&id=f0d3df6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d3df6e",
  null
  
)

export default component.exports